import { Reservations } from 'constants/interfaces'

const AI_SCORE_MIN = 0
const AI_SCORE_MAX = 100

export interface IParsedLLMResponse {
  aiScore: number
  feedbackText: string
  reservations: Reservations
}

/**
 * Parses and validates the raw LLM response string returned by /gpt/llm_interaction.
 * Converts the AI score into a score_deduction for the reservations payload.
 * Throws on invalid JSON, missing score, or out-of-range score.
 */
export const parseLLMResponse = (llmResponseStr: string): IParsedLLMResponse => {
  let parsed: any
  try {
    parsed = JSON.parse(llmResponseStr)
  } catch (e) {
    throw new Error(`Invalid JSON in llm_response: ${e}`)
  }

  const score = parsed?.score
  const text = parsed?.text

  if (score === undefined || score === null) {
    throw new Error('LLM response missing required field: score')
  }

  if (typeof score !== 'number' || score < AI_SCORE_MIN || score > AI_SCORE_MAX) {
    throw new Error(`Invalid AI score: ${score}. Must be between ${AI_SCORE_MIN}-${AI_SCORE_MAX}`)
  }

  const feedbackText = text || 'No feedback provided'

  return {
    aiScore: score,
    feedbackText,
    // score_deduction = 100 - score (reservations uses deduction, not raw score)
    reservations: {
      reasons: [feedbackText],
      score_deduction: 100 - score,
    },
  }
}
